import { InfoIcon } from 'assets/icons';
import BaseInput from 'Components/Form/BaseInput';
import Tooltip from 'Components/Tooltips';
import { concat } from 'lodash';
import { ReactNode, useState } from 'react';
import { RegisterOptions } from 'react-hook-form';
import * as Yup from 'yup';

export interface PasswordInputProps {
  name: string;
  rules?: RegisterOptions;
  label?: string;
  labelIcon?: React.ReactNode;
  placeholder?: string;
  autoComplete?: string;
}

export const passwordValidation = Yup.string()
  .trim()
  .required('required')
  .min(8, 'Password must be at least 8 characters');

export const PasswordInput = ({
  name,
  rules,
  autoComplete = 'on',
  placeholder = 'Enter your password...',
  ...rest
}: PasswordInputProps) => {
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown((prevState) => !prevState);
  };

  return (
    <BaseInput name={name} {...rest}>
      {({ register }) => (
        <div className="relative flex w-full flex-wrap items-stretch">
          <input
            {...register(name, rules)}
            type={passwordShown ? 'text' : 'password'}
            name={name}
            placeholder={placeholder}
            autoComplete={autoComplete}
            className="form__input"
          />
          <span
            className="h-full leading-snug font-normal absolute text-center text-gray-400 bg-transparent rounded text-base justify-center w-8 right-0 pr-3 py-4 flex items-center"
            style={{ pointerEvents: 'none' }}
          >
            {/* Icon removed for testing */}
          </span>
        </div>
      )}
    </BaseInput>
  );
};
